import Container from '@mui/material/Container';
import { BaseBreadcrumbs } from '@mgm/common/components/base';
import Stack from '@mui/material/Stack';
import { FormProvider, useForm } from 'react-hook-form';
import LoadingButton from '@mui/lab/LoadingButton';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';
import { CustomRangePicker } from '../../components/pickers';
import { ROUTES } from '../../data';
import { PAGES_ANALYTICS_TITLES, QUERY_KEYS } from '../../utils/enums';
import { PageHelmet } from '../../components';
import { OrdersCountLoader } from '../../features/orders/Shared/components';
import { useAppSelector } from '../../hooks/useAppStore';
import { getOrdersChosenDates } from '../../store/orders/selectors';
import { useOrders } from '../../features/orders/Shared/hooks';
import { useCommonOrders } from '../../hooks/useCommonOrders';
import { getTokenDetails } from '../../store/authenticate/selectors';
import { useOrdersByDates } from '../../features/orders/Shared/hooks/useOrdersByDates';
import { TeamAnalyticsView } from '../../features/orders/DailyStats/TeamAnalyticsView';

const CommissionTeamAnalyticsPage = () => {
  const { t } = useTranslation('nav');

  const { settings } = useAppSelector(getTokenDetails);

  const ordersChosenDates = useAppSelector(getOrdersChosenDates);
  const {
    ordersSetDates,
    isBtnDisabled,
    setIsBtnDisabled,
  } = useOrders();

  const queryClient = useQueryClient();

  const isOrdersInCache = !!queryClient.getQueryData([QUERY_KEYS.ORDERS.GET_ORDERS]);

  const { setIsFetchByDate } = useCommonOrders({
    prevTab: isOrdersInCache ? '1' : '',
  });

  const { getOrdersByDates } = useOrdersByDates(setIsBtnDisabled, setIsFetchByDate);

  const methods = useForm({
    mode: 'all',
    values: {
      dateRange: ordersChosenDates,
    },
  });

  return (
    <PageHelmet title={PAGES_ANALYTICS_TITLES.ANALYTICS.COMMISSION_TEAMS}>
      <Container
        sx={{
          px: {
            xs: 0, lg: 2, md: 2, sm: 2,
          },
        }}
        maxWidth={false}
      >
        <BaseBreadcrumbs
          heading="Team commissions analytics"
          links={[
            { name: t('analytics'), href: ROUTES.ANALYTICS.COMMISSION_INDIVIDUAL },
            { name: 'Team commissions analytics', href: ROUTES.ANALYTICS.COMMISSION_INDIVIDUAL },
          ]}
          action={(
            <Stack>
              <Stack spacing={2} direction="row" alignItems="center" justifyContent="flex-end">
                <FormProvider {...methods}>
                  <CustomRangePicker
                    format={settings.ui?.dateFormat}
                    defaultValue={ordersChosenDates}
                    setDates={ordersSetDates}
                  />
                  <LoadingButton
                    disabled={isBtnDisabled}
                    onClick={getOrdersByDates}
                    size="small"
                    variant="contained"
                  >
                    {t('load', { ns: 'common' })}
                  </LoadingButton>
                </FormProvider>
              </Stack>
              <OrdersCountLoader isDisplayDivider={false} />
            </Stack>
          )}
        />
        <TeamAnalyticsView />
      </Container>
    </PageHelmet>
  );
};

export {
  CommissionTeamAnalyticsPage,
};
